export default "__VITE_ASSET__BoaCRDdu__"